import { render, staticRenderFns } from "./EformTrackingComponent.vue?vue&type=template&id=72a76650&scoped=true&"
import script from "./EformTrackingComponent.vue?vue&type=script&lang=js&"
export * from "./EformTrackingComponent.vue?vue&type=script&lang=js&"
import style0 from "./EformTrackingComponent.vue?vue&type=style&index=0&id=72a76650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a76650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
